import {FC, useEffect, useState} from "react";
import classes from './AssignMedicationTemplate.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {APPLY_MEDICATION_TEMPLATE_REQUEST, GET_MEDICATION_TEMPLATES_REQUEST} from "../../../../../redux/actions";
import {medicationTemplatesSelector} from "../../../../../redux/selectors/treatmentPlansSelector";
import {Button, Chip, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {Modal} from "../../../../common/Modal/Modal";
import {IMedicationTemplate} from "../../../../../utils/interfaces";
import {useLocation} from "react-router-dom";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {format} from "date-fns";
import {getMedicationFromTemplateText} from "../../../../../utils/commonUtils";

export const AssignMedicationTemplate: FC = () => {
  const location = useLocation();
  const patientId = location.pathname.split('/').pop() || '';

  const dispatch = useDispatch();
  const medicationPlans = useSelector(medicationTemplatesSelector);
  const [selectedTemplate, setSelectedTemplate] = useState<IMedicationTemplate | null>(null);
  const [startDate, setStartDate] = useState<any>(null);

  useEffect(() => {
    dispatch({
      type: GET_MEDICATION_TEMPLATES_REQUEST,
      payload: {searchString: ''}
    });
  }, [dispatch]);

  const applyMedicationTemplate = () => {
    if (selectedTemplate) {
      dispatch({
        type: APPLY_MEDICATION_TEMPLATE_REQUEST,
        payload: {
          patientId,
          startDate: format(startDate ?? new Date(), 'yyyy-MM-dd'),
          templateId: selectedTemplate.id,
          callback: () => {
            setSelectedTemplate(null);
            setStartDate(null);
          }
        }
      })
    }
  }

  return (
    <>
      <div className={classes.container}>
        <div>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              className={classes.dateInput}
              format="dd.MM.yyyy"
              onChange={newValue => setStartDate(newValue)}
              slotProps={{
                textField: {
                  placeholder: "Choose Start Day",
                  variant: "outlined"
                }
              }}
              value={startDate}
            />
          </LocalizationProvider>
        </div>
        <TableContainer className={classes.tableContainer}>
          <Table className={classes.table} stickyHeader>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell align="left">Plan Name</TableCell>
                <TableCell align="left">Medications</TableCell>
                <TableCell align="left">Times</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={classes.tableBody}>

              {medicationPlans &&
                medicationPlans.map(
                  (template) => {
                    return (
                      <TableRow className={classes.tableRow} key={template.id}>
                        <TableCell align="left">{template.name}</TableCell>
                        <TableCell align="left">
                          <Stack spacing={2}>
                            {template.items.map((medication, index) => (
                              <span key={medication.id}>
                                {getMedicationFromTemplateText(medication, index)}
                              </span>
                            ))}
                          </Stack>
                        </TableCell>
                        <TableCell align="left">
                          <Stack spacing={2}>
                            {template.items.map((medication, index) => (
                              <Stack direction="row" spacing={1} key={index}>
                                {medication.times.map((time, index) => {
                                  const splittedTime = time.split(':');
                                  const formattedTime = `${splittedTime[0]}:${splittedTime[1]}`;

                                  return (
                                    <Chip sx={{minWidth: 60}} color="primary" size="small" key={index} label={formattedTime} variant="filled" />
                                  )
                                })}
                              </Stack>
                            ))}
                          </Stack>
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            disabled={template.items.every(medication => !!medication.startDayAfterSurgery) ? false : !startDate}
                            variant="contained"
                            onClick={() => setSelectedTemplate(template)}
                          >
                            Apply
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  }
                )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <Modal
        open={!!selectedTemplate?.id}
        title={"Apply template"}
        message={`Are you sure you want to apply this medication template to this patient starting from ${startDate ? format(startDate, 'dd.MM.yyyy') : ''}?`}
        handleConfirm={applyMedicationTemplate}
        handleCancel={() => setSelectedTemplate(null)}
      />
    </>
  );
}